export const LOADING_MFA_SETTINGS = 'LOADING_MFA_SETTINGS';
export const LOADED_MFA_SETTINGS = 'LOADED_MFA_SETTINGS';
export const UPDATING_MFA_SETTINGS = 'UPDATING_MFA_SETTINGS';
export const UPDATED_MFA_SETTINGS = 'UPDATED_MFA_SETTINGS';
export const SENDING_SMS_VERIFICATION = 'SENDING_SMS_VERIFICATION';
export const SENT_SMS_VERIFICATION = 'SENT_SMS_VERIFICATION';
export const VALIDATING_SMS_PHONE = 'VALIDATING_SMS_PHONE';
export const VALIDATED_SMS_PHONE = 'VALIDATED_SMS_PHONE';
export const ERROR_MFA_SETTINGS = 'ERROR_MFA_SETTINGS';

export interface LoadingMFASettings {
    type: typeof LOADING_MFA_SETTINGS;
}

export interface LoadedMFASettings {
    type: typeof LOADED_MFA_SETTINGS;
    payload: any;
}

export interface UpdatingMFASettings {
    type: typeof UPDATING_MFA_SETTINGS;
}

export interface UpdatedMFASettings {
    type: typeof UPDATED_MFA_SETTINGS;
    payload: any;
}

export interface SendingSMSVerification {
    type: typeof SENDING_SMS_VERIFICATION;
}

export interface SentSMSVerification {
    type: typeof SENT_SMS_VERIFICATION;
    payload: any;
}

export interface ValidatingSMSPhone {
    type: typeof VALIDATING_SMS_PHONE;
}

export interface ValidatedSMSPhone {
    type: typeof VALIDATED_SMS_PHONE;
    payload: any;
}

export interface ErrorMFASettings {
    type: typeof ERROR_MFA_SETTINGS;
    payload: string;
}

export type MfaActionTypes = LoadingMFASettings
    | LoadedMFASettings
    | UpdatingMFASettings
    | UpdatedMFASettings
    | SendingSMSVerification
    | SentSMSVerification
    | ValidatingSMSPhone
    | ValidatedSMSPhone
    | ErrorMFASettings;

export interface MfaSettingsModel {
    canToggleEnrollment: boolean;
    isEnrolled: boolean;
    mfaEmail: string;
    mfaPhone: string;
    availableTypes: availableType[];
    isValidating: boolean;
    isLoading: boolean;
    isValidatingSms: boolean;
    smsVerificationMessage: string;
    saveValidationMessage: string;
    saveCompleted: boolean;
    isValidated: boolean;
}

export interface availableType {
    type: string;
    description: string;
    isSelected: boolean;
    isPreferred: boolean;
}

export interface TypeSelection {
    Email: availableType;
    SMS: availableType;
}